import * as React from 'react';
import ProjectTeamMember from 'src/value-objects/ProjectTeamMembers';
import './UpdateTeamMembers.css';
import ReactDropzone, { ImageFile } from 'react-dropzone';
import ErrorMessagesComponent from 'src/modules/commons/error-messages/ErrorMessages.component';
import InputContainer from 'src/modules/commons/inputs/input/Input.container';
import ImageContainer from 'src/modules/commons/images/Image.container';
import { baseApiRoute } from 'src/resources/const';
import RichEditContainer from 'src/modules/commons/inputs/rich-edit/RichEdit.container';

export interface ProjectUpdateTeamMemberCardComponentProps {
  teamMember: ProjectTeamMember;
  formData: ProjectTeamMember;
  profilePicture?: File;
  editTeamMember: () => void;
  edit: boolean;
  deleteTeamMember: () => void;
  handleChange: (key: string) => (value: string | File) => void;
  handleRichEditor: (key: string) => (value: string | File) => void;
  handleSubmit: () => void;
  errorMessage: {};
}

class ProjectUpdateTeamMemberCardComponent extends React.Component<ProjectUpdateTeamMemberCardComponentProps> {
  public render(): React.ReactNode {
    return (
      <div className="update-team-member-card padding-20">
        {this.props.edit ?
          <div className="padding-20">
            <div className="row">
              <div className="col-md-6">
                <div className="row padding-l-r-10">
                  <div className="md-input">
                    <InputContainer
                      label="Nombre completo"
                      type="text"
                      value={this.props.formData.fullName}
                      onChange={(value) => this.props.handleChange('fullName')(value)}
                      required={true}
                    />
                  </div>
                </div>
                <div className="row padding-l-r-10">
                  <div className="md-input">
                    <InputContainer
                      label="Posición"
                      type="text"
                      value={this.props.formData.jobTitle}
                      onChange={(value) => this.props.handleChange('jobTitle')(value)}
                      required={true}
                    />
                  </div>
                </div>
                <div className="row padding-l-r-10">
                  <div className="md-input">
                    <InputContainer
                      label="Usuario Linkedin"
                      type="text"
                      value={this.props.formData.linkedinProfile || ''}
                      onChange={(value) => this.props.handleChange('linkedinProfile')(value)}
                      required={true}
                    />
                  </div>
                </div>
                <div className="row padding-l-r-10">
                  <ReactDropzone
                    className="dropzone text-center pointer"
                    onDrop={(files: ImageFile[]) => {
                      if (files[0]) {
                        this.props.handleChange('profilePicture')(files[0]);
                      }
                    }}
                    multiple={false}
                    accept="image/*"
                  >
                    <ImageContainer
                      alt="profile picture"
                      url={
                        (this.props.formData.profilePicture && !this.props.formData.profilePicture.encoded) ?
                          this.props.formData.profilePicture.url :
                          ''
                      }
                      defaultImagePath={
                        this.props.formData.profilePicture ?
                          this.props.formData.profilePicture.url :
                          '/img/pic.png'
                      }
                    />
                    <div className="gap-10"/>
                    <p className="text-center">
                      Arrastre una foto / Clique aquí...
                    </p>
                  </ReactDropzone>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row padding-left-20">
                  <RichEditContainer
                    onChange={(value) => this.props.handleRichEditor('description')(value)}
                    placeholder="Añade la descripción"
                    uploadURL={baseApiRoute + '/save-image'}
                    value={this.props.formData.description}
                  />
                </div>
              </div>
            </div>
            <div className="add-team-member text-right">
              <div className="gap-20"/>
              <button
                type="button"
                className="btn btn-primary"
                data-container="body"
                data-html="true"
                data-toggle="popover"
                data-placement="bottom"
                onClick={(e) => this.props.handleSubmit()}
              >
                Guardar
              </button>
              <div className="gap-20"/>
              <ErrorMessagesComponent
                errorMessage={this.props.errorMessage}
              />
            </div>
          </div> :
          <section>
            <div
              className="close-circle pointer"
              onClick={() => this.props.deleteTeamMember()}
            >
              <span className="close-med"/>
            </div>
            <div
              className="row Aligner"
            >
              <div className="col-md-4 profile-picture">
                <ImageContainer
                  className="fit-image"
                  alt={this.props.teamMember.fullName}
                  url={
                    (this.props.formData.profilePicture && !this.props.formData.profilePicture.encoded) ?
                      this.props.formData.profilePicture.url :
                      ''
                  }
                  defaultImagePath={
                    this.props.formData.profilePicture ?
                      this.props.formData.profilePicture.url :
                      '/img/user-profile-big.png'
                  }
                />
              </div>
              <div className="col-md-8 Aligner-item" style={{left: ' 30px'}}>
                <div className="row">
                  <div className="teamName">
                    {this.props.teamMember.fullName},
                  </div>
                </div>
                <div className="row deco-title">
                  <div className="jobTitle">
                    {this.props.teamMember.jobTitle}
                  </div>
                </div>
                <div className="row" style={{marginBottom: '15px'}}>
                  <div
                    className="from-rich-editor descript"
                    dangerouslySetInnerHTML={{__html: this.props.teamMember.description}}
                  />
                </div>
                {this.props.teamMember.linkedinProfile ?
                  <div className="row">
                    <strong>Linkedin: </strong>
                    <a
                      href={this.props.teamMember.linkedinProfile}
                      className="linkedin-team"
                      target="_blank"
                    >
                      {this.props.teamMember.linkedinProfile}
                    </a>
                  </div> : null
                }
              </div>
            </div>
            <div className="text-right">
              <button
                type="button"
                className="btn"
                data-container="body"
                data-html="true"
                data-toggle="popover"
                data-placement="bottom"
                onClick={(e) => this.props.editTeamMember()}
              >
                Editar
              </button>
            </div>
          </section>
        }
      </div>
    );
  }
}

export default ProjectUpdateTeamMemberCardComponent;



// WEBPACK FOOTER //
// ./src/modules/project/update/partials/round-information/ProjectUpdateTeamMemberCard.component.tsx